module.exports = __webpack_public_path__ + "img/denis_1_2x.b6e805ee.jpg";